import { useState } from 'react';
import { FAQS } from '@/mocks/data';

function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              常见问题
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-[32px]">你想知道的都在这里</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于更新频率、分类使用、榜单算法与内容转载的疑问,我们整理了最高频的几个问题。如果还有不清楚的地方,欢迎直接联系我们。
            </p>
            <button
              type="button"
              onClick={() => scrollToId('subscribe')}
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              反馈你的问题
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={i}>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                      aria-expanded={isOpen}
                    >
                      <span className="flex items-start gap-3">
                        <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-black ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-700'}`}>
                          Q{i + 1}
                        </span>
                        <span className="text-sm font-bold leading-snug text-foreground-900 md:text-base">{f.q}</span>
                      </span>
                      <i className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-400 transition-transform ${isOpen ? 'rotate-180 text-primary-600' : ''}`}></i>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6">
                        <p className="ml-9 max-w-3xl border-l-2 border-primary-200 pl-4 text-sm leading-relaxed text-foreground-700">
                          {f.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}